import { Component, OnInit } from '@angular/core';
import { BookingPreConfirmationTemplate } from '../booking-pre-confirmation-template';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';

@Component({
  selector: 'app-booking-pre-confirmation-templates',
  templateUrl: './booking-pre-confirmation-templates.component.html',
  styleUrls: ['./booking-pre-confirmation-templates.component.css']
})
export class BookingPreConfirmationTemplatesComponent implements OnInit {

  templates: BookingPreConfirmationTemplate[] = [];

  constructor(
    private httpService: HttpService,
    private templateService: PdfDocumentTemplateService
  ) { }

  ngOnInit(): void {
    this.httpService.getBookingPreConfirmationTemplates().subscribe(res => {
      this.templates = res;
    });
  }

  selectTemplateToEdit(template: BookingPreConfirmationTemplate){
    this.templateService.selectedPreConfirmationTemplate = template;
    this.templateService.activeItemId = PdfTemplateViewOption.EDIT_PRE_CONFIRMATION;
  }
}
